module.exports = __webpack_public_path__ + "img/start.a48cdae5.svg";